import cx from 'classnames'
import styles from './AvatarSelector.module.css'
import { type AvatarSubject, Avatar } from '@/components/Avatar'
import { FileButton } from '@/components/FileButton'
import { Icon } from '@/components/Icon'
import { Spinner } from '@/components/Spinner'

interface AvatarSelectorProps {
  subject: AvatarSubject
  size?: number
  isUploading?: boolean

  onSelectNewFile?(file: File): unknown
}

/**
 * An avatar that opens a file picker to upload a new picture.
 */
export function AvatarSelector({
  subject,
  isUploading,
  onSelectNewFile,
  size = 48,
}: AvatarSelectorProps) {
  return (
    <div className={cx(styles.root, isUploading && styles.pending)}>
      <div className={styles.avatar}>
        <Avatar size={size} subject={subject} />
      </div>
      <div className={styles.avatarInput}>
        <Icon name="camera" color="var(--white)" />
        <FileButton
          overlay
          onChange={(files: FileList) => onSelectNewFile?.(files[0])}
          accept=".png,.jpg,.jpeg"
        />
      </div>
      <div className={styles.spinner}>
        <Spinner size={size + 8} thickness={2} />
      </div>
    </div>
  )
}
